<template>
    <Header subTitle="Une page simple et clair" />

    <Main>
        <FullContainerWithMedia>
            <h2>
                Un point d'entrée clair et impactant
            </h2>
            <p>
                Une landing page bien conçue permet de concentrer vos messages, vos offres et vos appels
                à l'action en un seul endroit stratégique. Couplée à un QR code, elle devient le point de
                contact parfait pour vos campagnes print, événements ou packaging.
            </p>
            <NuxtLink to="https://s-keyp.github.io/myPortfolio/Projets/Centaury/index.html" target="_blank">Voir la
                landing page</NuxtLink>

            <template #video>
                <video controls muted loop src="~/assets/videos/centaury-vid.mp4" alt="Landing page demo"
                    type="video/mp4"> </video>
            </template>
        </FullContainerWithMedia>

        <FullContainer>
            <h2>
                Une page stable et inaltérable
            </h2>
            <p>
                Contrairement à un site web dynamique, une landing page statique ne change pas et reste
                accessible de manière fiable, quel que soit le moment ou l'endroit. Elle garantit que vos
                visiteurs retrouvent toujours le même message, le même visuel et le même appel à l'action,
                sans risque de rupture ou de contenu obsolète. Un atout idéal pour des campagnes qui doivent
                rester cohérentes dans le temps.
            </p>
        </FullContainer>

        <FullContainerWithMedia reversed>
            <h2>
                Une landing page accessible en un scan
            </h2>
            <p>
                Oubliez les longues URLs ou les recherches fastidieuses. Grâce à un QR code unique, vos
                visiteurs accèdent instantanément à votre landing page, où qu'ils soient. En un seul scan,
                vous captez leur attention et les amenez directement à l'essentiel. C'est simple, rapide et
                redoutablement efficace.
            </p>

            <template #img>
                <img src="~/assets/images/qr-byte-hive.png" alt="QR Byte Hive" />
            </template>
        </FullContainerWithMedia>

        <Tariffs>
            <h2>
                Nos Tarifs
            </h2>
            <p>
                Transformez vos visiteurs en clients grâce à une landing page percutante.
                Design moderne, messages clairs et options sur mesure (QR Code inclus) pour maximiser vos conversions.
            </p>
            <template #table>
                <table class="tariffs-table" cellpadding="10" cellspacing="0"
                    style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                    <thead style="background-color: #f4f4f4;">
                        <tr>
                            <th>Option</th>
                            <th>Description</th>
                            <th>Prix à partir de (€)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Design</td>
                            <td>Création graphique, UX/UI, respect de la charte</td>
                            <td>150 €</td>
                        </tr>
                        <tr>
                            <td>Développement de base</td>
                            <td>Intégration HTML/CSS/JS, responsive, CTA</td>
                            <td>300 €</td>
                        </tr>
                        <tr>
                            <td>Hébergement</td>
                            <td>Serveur mutualisé + certificat SSL</td>
                            <td>5 €/mois</td>
                        </tr>
                        <tr>
                            <td>Maintenance / Support</td>
                            <td>Mises à jour, sauvegardes, corrections</td>
                            <td>50 €/mois</td>
                        </tr>
                        <tr>
                            <td>Option QR Code</td>
                            <td>Génération et intégration d'un QR Code personnalisé</td>
                            <td>30 €</td>
                        </tr>
                        <tr style="background-color: #fafafa; font-weight: bold;">
                            <td>Pack complet</td>
                            <td>Design + développement + hébergement de base</td>
                            <td>500 €</td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </Tariffs>
    </Main>
</template>

<script setup>
useSeoMeta({
    title: "Byte Hive — Landing Page efficace & impactante",
    description: "Conception de landing page simple, claire et orientée action avec Byte Hive. Transformez vos campagnes print ou digitales en points de contact performants grâce à un QR code et un message ciblé.",
    ogTitle:"Byte Hive — Landing Page efficace & impactante",
    ogDescription:"Une landing page simple et claire, optimisée pour la conversion, idéale pour vos campagnes avec QR code ou supports print",
    ogImage: "https://byte-hive.fr/byte-hive-og-image.png",
    ogUrl: "https://byte-hive.fr/landing-page",
    ogType: "website",
});
</script>

<style scoped lang="scss">
@use "./index.scss";
</style>
